import AbstractRequestTask from "../AbstractRequestTask";
import Device from "../../../devices/device";
import getAppConfig from "../../../config/appConfig";
import AAF from "src/AAF/AAF";
class ApaMetadataMiddlewareTask extends AbstractRequestTask {
  constructor(region = "", appKey = '') {
    super();

    this.region = region;
    this.appKey = appKey;
  }

  isValid (data){
    return (typeof data == 'object')

  }

  getUrl() {
    return getAppConfig().end_point_middleware + 'metadata';  
  }

  getParams() {
    const params = super.getParams();

    const appKey = this.appKey ? this.appKey : Device.getDevice().getConfig().appKey;
    const region = this.region || params.region;
    const sessionKey = `${appKey}-${region}`;
    const adsEnabledDevice = AAF.AdsUtils.isTVPlatformSupported().support || false;

    const newParams = {
      sessionKey,
      region,
      adsEnabledDevice
    };

    return Object.assign({}, params, newParams);
  }

  success(data, b) {
    this.resolve(data);
  }
  //TODO: investigate if we need to set zero the number of retries in all of cases or only in plan selector
  getRetriesNumber() {
    return 0;
  }
}

export default ApaMetadataMiddlewareTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/application/ApaMetadataMiddlewareTask.js